import { render } from "./MsDoughnutChart.vue?vue&type=template&id=df42c85e&scoped=true&ts=true"
import script from "./MsDoughnutChart.vue?vue&type=script&lang=ts"
export * from "./MsDoughnutChart.vue?vue&type=script&lang=ts"

import "./MsDoughnutChart.vue?vue&type=style&index=0&id=df42c85e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df42c85e"]])

export default __exports__